import {CurrentUserProvider} from '@github-ui/agent-sessions/contexts/CurrentUserContext'
import {CustomizeView} from '@github-ui/copilot-connectors/components/CustomizeView'
import {ConsecutiveCAPI401sProvider} from '@github-ui/copilot-shared-ui/capi/ConsecutiveCAPI401sContext'
import {setTitle} from '@github-ui/document-metadata'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useCurrentQueryRoute} from '@github-ui/react-core/future/use-current-query-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {AppPayloadContext} from '@github-ui/react-core/use-app-payload'
import {useEffect} from 'react'

import type {CopilotAgentsCustomizePayload} from '../../types/copilot-agents-customize-payload'
import {AgentsSidebarLayout} from '../AgentsSidebarLayout'
import {AgentsCustomizePageContent} from './AgentsCustomizePageContent'

export function CopilotAgentsCustomizePage() {
  const currentRoute = useCurrentQueryRoute()
  const {data: payload} = useRouteQuery(currentRoute, 'mainQuery')

  if (!payload) {
    return null
  }

  return <CopilotAgentsCustomizePageContent payload={payload as CopilotAgentsCustomizePayload} />
}

export function CopilotAgentsCustomizePageContent({payload}: {payload: CopilotAgentsCustomizePayload}) {
  useEffect(() => {
    setTitle('Customize · GitHub Copilot')
  }, [])

  return (
    <AppPayloadContext value={payload}>
      <CurrentUserProvider currentUser={payload.currentUser} currentUserIsSessionOwner>
        <ConsecutiveCAPI401sProvider>
          <ErrorBoundary boundaryName="CopilotAgentsCustomizePageContent">
            <AgentsSidebarLayout
              agentsEnabled={!!payload.agentsEnabled}
              showSpacesNav={payload.spacesEnabled}
              showCustomizeNav={payload.customizeEnabled}
              enterpriseSandboxEnabled={payload.enterpriseSandboxEnabled !== false}
              currentUserLogin={payload.currentUser?.login}
              currentUserId={payload.currentUser?.id}
              taskGroups={payload.taskGroups}
              contentKey="customize"
              sidebarProps={{isCustomizeActive: true}}
            >
              <AgentsCustomizePageContent>
                {payload.customizeEnabled ? <CustomizeView /> : <p>Customize is not enabled for your account.</p>}
              </AgentsCustomizePageContent>
            </AgentsSidebarLayout>
          </ErrorBoundary>
        </ConsecutiveCAPI401sProvider>
      </CurrentUserProvider>
    </AppPayloadContext>
  )
}
